import React, {useEffect, useState} from "react";
import {Select, SelectProps} from "@mantine/core";
import {xfetch, HttpVerbo} from "../../util";

// @ts-ignore
interface SelectFetchMantineProps  extends SelectProps, React.ComponentPropsWithoutRef<'select'> {
    url: string,
    multiplo?: boolean
    ids?: number[],
}

interface SelectItens {
    id: number;
    nome: string;
}

export default function SelectFetchMantine(props: Readonly<SelectFetchMantineProps>) {

    const [isCarregando, setIscarregando] = useState(false)
    const [lista, setLista] = useState<SelectItens[]>([])

    const consultaLista = async () => {
        setIscarregando(true)
        const res = await xfetch(props.url, {}, HttpVerbo.GET)
        const json = await res.json()
        setLista(json)
        setIscarregando(false)
    }

    useEffect(() => {
        consultaLista()
    }, [])

    const options = lista?.length > 0 ? lista.map((item: any) => {
        return {key: item.id ,value: item.id.toString(), label: item.nome}}) : [];

    function getData() {
        if (!props.ids) return options
        else return options.filter(o => Number(o.value) === props.ids?.find(id => id?.toString() === o.value))
    }

  return (
          <Select
              data={getData()}
              searchable
              clearable
              disabled={isCarregando}
              nothingFoundMessage="Nenhum resultado encontrado..."
              {...props}
          />
  );
}

